// Shared portfolio data for carousel and pages
// Project themes mapped to planets per BUILD_INSTRUCTIONS.md

// Unsplash source images — themed per project, reliable CDN delivery
const U = "https://images.unsplash.com";

export const portfolioItems = [
  {
    id: "mercury",
    image: "#7c8493",
    text: "#dfe8ff",
    title: "Electrical Systems",
    subtitle: "embedded control",
    description:
      "Firmware and hardware interfaces for real-time systems. Mercury moves fast — so do these low-level controllers. Hover to see a probe scan the circuits.",
    role: "Electrical Programming",
    client: "Hardware Projects",
    poster: `${U}/photo-1518770660439-4636190af475?w=800&h=800&fit=crop`, // circuits
    images: [
      `${U}/photo-1518770660439-4636190af475?w=1200&h=800&fit=crop`, // circuit board
      `${U}/photo-1555664424-778a1e5e1b48?w=1200&h=800&fit=crop`, // electronics
      `${U}/photo-1581091226825-a6a2a5aee158?w=1200&h=800&fit=crop`, // tech hardware
      `${U}/photo-1563770660941-20978e870e26?w=1200&h=800&fit=crop`, // microchip
      `${U}/photo-1517077304055-6e89abbf09b0?w=1200&h=800&fit=crop`, // wiring
      `${U}/photo-1550751827-4bd374c3f58b?w=1200&h=800&fit=crop`, // PCB macro
    ],
    color: "#7c8493",
  },
  {
    id: "venus",
    image: "#d48a4a",
    text: "#ffe6b6",
    title: "Solar Racer",
    subtitle: "sun-powered motion",
    description:
      "A solar-powered vehicle project combining energy efficiency with performance engineering. Venus basks in sunlight — this car does too. Hover to catch light reflecting off the panels.",
    role: "Solar Car Project",
    client: "Renewable Energy",
    poster: `${U}/photo-1509391366360-2e959784a276?w=800&h=800&fit=crop`, // solar panels
    images: [
      `${U}/photo-1509391366360-2e959784a276?w=1200&h=800&fit=crop`, // solar panels field
      `${U}/photo-1508514177221-188b1cf16e9d?w=1200&h=800&fit=crop`, // sunset energy
      `${U}/photo-1473341304170-971dccb5ac1e?w=1200&h=800&fit=crop`, // sun rays
      `${U}/photo-1532601224476-15c79f2f7a51?w=1200&h=800&fit=crop`, // solar tech
      `${U}/photo-1466611653911-95081537e5b7?w=1200&h=800&fit=crop`, // wind & solar
      `${U}/photo-1497440001374-f26997328c1b?w=1200&h=800&fit=crop`, // golden light
    ],
    color: "#d48a4a",
  },
  {
    id: "earth",
    image: "#1a58e2",
    text: "#cfe6ff",
    title: "Eco Simulator",
    subtitle: "green planet",
    description:
      "An environmental simulation modeling ecosystems, climate patterns, and sustainability metrics. Our home planet — and the systems that keep it alive. Hover to watch the clouds move.",
    role: "Environmental Simulation",
    client: "Climate Research",
    poster: `${U}/photo-1451187580459-43490279c0fa?w=800&h=800&fit=crop`, // earth from space
    images: [
      `${U}/photo-1451187580459-43490279c0fa?w=1200&h=800&fit=crop`, // earth from space
      `${U}/photo-1446776811953-b23d57bd21aa?w=1200&h=800&fit=crop`, // earth blue marble
      `${U}/photo-1470071459604-3b5ec3a7fe05?w=1200&h=800&fit=crop`, // green nature
      `${U}/photo-1441974231531-c6227db76b6e?w=1200&h=800&fit=crop`, // forest
      `${U}/photo-1501854140801-50d01698950b?w=1200&h=800&fit=crop`, // aerial nature
      `${U}/photo-1498050108023-c5249f4df085?w=1200&h=800&fit=crop`, // code on screen
    ],
    color: "#1a58e2",
  },
  {
    id: "mars",
    image: "#b44b33",
    text: "#ffd1c6",
    title: "Red Frontier",
    subtitle: "adventure game",
    description:
      "An exploration game set on an alien landscape. Dust storms, resource management, and discovery. Hover to see the rover roll across the terrain.",
    role: "Game Development",
    client: "Interactive Media",
    poster: `${U}/photo-1614728894747-a83421e2b9c9?w=800&h=800&fit=crop`, // mars surface
    images: [
      `${U}/photo-1614728894747-a83421e2b9c9?w=1200&h=800&fit=crop`, // mars landscape
      `${U}/photo-1545156521-77bd85671d30?w=1200&h=800&fit=crop`, // red desert
      `${U}/photo-1534088568595-a066f410bcda?w=1200&h=800&fit=crop`, // desert dunes
      `${U}/photo-1517483000871-1dbf64a6e1c6?w=1200&h=800&fit=crop`, // game controller
      `${U}/photo-1550745165-9bc0b252726f?w=1200&h=800&fit=crop`, // retro gaming
      `${U}/photo-1536697246787-1f7ae568714d?w=1200&h=800&fit=crop`, // canyon
    ],
    color: "#b44b33",
  },
  {
    id: "jupiter",
    image: "#c29970",
    text: "#fff1db",
    title: "Cloud Platform",
    subtitle: "full stack system",
    description:
      "A scalable backend architecture handling massive data flows. Like Jupiter's gravity, it pulls everything together. Hover to watch the storm swirl.",
    role: "Full Stack Development",
    client: "Enterprise Systems",
    poster: `${U}/photo-1544197150-b99a580bb7a8?w=800&h=800&fit=crop`, // server room
    images: [
      `${U}/photo-1544197150-b99a580bb7a8?w=1200&h=800&fit=crop`, // server room
      `${U}/photo-1558494949-ef010cbdcc31?w=1200&h=800&fit=crop`, // data center
      `${U}/photo-1451187580459-43490279c0fa?w=1200&h=800&fit=crop`, // network globe
      `${U}/photo-1484417894907-623942c8ee29?w=1200&h=800&fit=crop`, // code laptop
      `${U}/photo-1504639725590-34d0984388bd?w=1200&h=800&fit=crop`, // code screen
      `${U}/photo-1517694712202-14dd9538aa97?w=1200&h=800&fit=crop`, // laptop code
    ],
    color: "#c29970",
  },
  {
    id: "saturn",
    image: "#b8a489",
    text: "#fff0df",
    title: "Portfolio Site",
    subtitle: "web experience",
    description:
      "A motion-first portfolio with 3D visuals and smooth interactions. Rings of content orbit the core. Hover to set the rings in motion.",
    role: "Website Development",
    client: "Personal Brand",
    poster: `${U}/photo-1547658719-da2b51169166?w=800&h=800&fit=crop`, // web design
    images: [
      `${U}/photo-1547658719-da2b51169166?w=1200&h=800&fit=crop`, // web design mockup
      `${U}/photo-1507003211169-0a1dd7228f2d?w=1200&h=800&fit=crop`, // portrait
      `${U}/photo-1460925895917-afdab827c52f?w=1200&h=800&fit=crop`, // dashboard
      `${U}/photo-1522542550221-31fd19575a2d?w=1200&h=800&fit=crop`, // wireframe
      `${U}/photo-1559028012-481c04fa702d?w=1200&h=800&fit=crop`, // design tools
      `${U}/photo-1558655146-9f40138edfeb?w=1200&h=800&fit=crop`, // UI components
    ],
    color: "#b8a489",
  },
  {
    id: "uranus",
    image: "#62d8ff",
    text: "#d6fbff",
    title: "Experimental Lab",
    subtitle: "miscellaneous",
    description:
      "A collection of side projects, prototypes, and creative experiments. Tilted perspective, unexpected results. Hover to see the axis wobble.",
    role: "Miscellaneous",
    client: "Creative Exploration",
    poster: `${U}/photo-1507413245164-6160d8298b31?w=800&h=800&fit=crop`, // lab experiment
    images: [
      `${U}/photo-1507413245164-6160d8298b31?w=1200&h=800&fit=crop`, // science lab
      `${U}/photo-1532094349884-543bc11b234d?w=1200&h=800&fit=crop`, // chemistry
      `${U}/photo-1485827404703-89b55fcc595e?w=1200&h=800&fit=crop`, // robot
      `${U}/photo-1535378917042-10a22c95931a?w=1200&h=800&fit=crop`, // 3D render
      `${U}/photo-1558618666-fcd25c85f82e?w=1200&h=800&fit=crop`, // neon lights
      `${U}/photo-1550684848-fac1c5b4e853?w=1200&h=800&fit=crop`, // abstract light
    ],
    color: "#62d8ff",
  },
  {
    id: "pluto",
    image: "#b7a8a2",
    text: "#ffe3ea",
    title: "Distant Archive",
    subtitle: "legacy projects",
    description:
      "Older work that shaped the journey. Small but meaningful. Hover to watch Charon loop close by.",
    role: "Archive",
    client: "Past Work",
    poster: `${U}/photo-1446776811953-b23d57bd21aa?w=800&h=800&fit=crop`, // space
    images: [
      `${U}/photo-1446776811953-b23d57bd21aa?w=1200&h=800&fit=crop`, // deep space
      `${U}/photo-1462331940025-496dfbfc7564?w=1200&h=800&fit=crop`, // nebula
      `${U}/photo-1419242902214-272b3f66ee7a?w=1200&h=800&fit=crop`, // starry sky
      `${U}/photo-1454789548928-9efd52dc4031?w=1200&h=800&fit=crop`, // astronaut
      `${U}/photo-1516339901601-2e1b62dc0c45?w=1200&h=800&fit=crop`, // old books
      `${U}/photo-1481627834876-b7833e8f5570?w=1200&h=800&fit=crop`, // library
    ],
    color: "#b7a8a2",
  },
];
